import { WhenAllReady } from "@nimble/react-requests/components/shared/when-all-ready";
import { getInnerQueryData } from "@nimble/react-requests/data/response-utils";

import AppDrawer from "@/app/(discover)/components/app-drawer";
import JobDetailsContent from "@/components/shared/jobs/job-details/job-details-content";
import JobDetailsContentSkeleton from "@/components/shared/jobs/job-details/job-details-content.skeleton";
import useJobPostingData from "@/hooks/data/use-job-posting";
import useSchoolData from "@/hooks/data/use-school-data";
import { StateConfig } from "@/lib/states-config";

export default function JobDetailsDrawerView({
  jobQuery,
  schoolQuery,
  stateConfig,
  onClose,
}: {
  jobQuery: ReturnType<typeof useJobPostingData>;
  schoolQuery: ReturnType<typeof useSchoolData>;
  stateConfig: StateConfig;
  onClose: () => void;
}) {
  const jobPosting = getInnerQueryData(jobQuery);
  const schoolData = getInnerQueryData(schoolQuery);

  const maxH = "md:!max-h-[90vh]"; // Do not change max-h without looking at the Github PR blame!

  return (
    <AppDrawer
      onClose={onClose}
      title="Job Details"
      className={`p-0 ${maxH} will-change-transform`}
    >
      <div className="max-w-5xl w-full h-full mx-auto overflow-y-auto">
        <WhenAllReady
          queries={[jobQuery, schoolQuery]}
          loader={<JobDetailsContentSkeleton />}
          ErrorWrapper={({ errorEl }) => <div className="p-6">{errorEl}</div>}
        >
          {jobPosting && schoolData && (
            <JobDetailsContent
              jobPosting={jobPosting}
              schoolData={schoolData}
              stateConfig={stateConfig}
            />
          )}
        </WhenAllReady>
      </div>
    </AppDrawer>
  );
}
